/*
 * @Author: changcheng
 * @LastEditTime: 2024-11-13 10:09:27
 */
import { post, get, upload, del, put } from "@root/common/fetch";
import { UserDetailInfoProps } from "@root/actions/index";
import { getBrowser } from "@root/common/utils";
import {
  HomeMenu,
  HomeMoules,
  NewsItem,
  Result,
  ResultList,
} from "./interface/result";
interface pageProps {
  pageNum: number;
  pageSize: number;
}
const { NODE_ENV } = process.env;
const prefixpath = NODE_ENV === "development" ? "" : "/county-manager";
/**
 * 获取图片验证码
 * @param userName  姓名
 */
export async function getCodeImage() {
  const res = await get(`${prefixpath}/dev-api/code`, {}, false);
  return res;
}
/**
 * 注册获取短信验证码
 * @param smsCode 短信验证码
 * @param cellphone 手机号
 * @returns
 */
export async function sndSmsCode(cellphone: String) {
  const res = await get(
    `${prefixpath}/dev-api/system/sms/send-sms?cellphone=${cellphone}`,
    {},
    false
  );
  return res;
}
/**
 * 手机号是否存在
 * @param smsCode 短信验证码
 * @param cellphone 手机号
 * @returns
 */
export async function validatePhoneNumber(cellphone: String) {
  const res = await get(
    `${prefixpath}/dev-api/system/user/validate/phonenumber?key=${cellphone}`,
    {},
    false
  );
  return res;
}

/**
 * 查询手机号码是否已存在
 * @param phoneNumber 手机号码
 */
export async function searchExistPhoneNumber(phoneNumber: string) {
  const res = await get(
    `${prefixpath}/dev-api/system/user/validate/phonenumber?key=${phoneNumber}`,
    {},
    false
  );
  return res;
}
/**
 * 查询手机号码是否已报名
 * @param phoneNumber 手机号码
 */
export async function queryRegisterOrNot(phoneNumber: string) {
  const res = await get(
    `${prefixpath}/dev-api/system/user/validate/report/${phoneNumber}`,
    {},
    false
  );
  return res;
}
/**
 * 根据手机号码获取用户信息
 * @param phoneNumber 手机号码
 * @returns
 */
export async function getUserInfoByPhoneNum(phoneNumber: string) {
  const res = await get(
    `${prefixpath}/dev-api/system/user/report/${phoneNumber}`,
    {},
    false
  );
  return res;
}
/**
 * 注册获取短信验证码
 * @param smsCode 短信验证码
 * @param cellphone 手机号
 * @returns
 */
export async function checkSmsCode(cellphone: String, smsCode: String) {
  const res = await post(
    `${prefixpath}/dev-api/system/sms/checksms`,
    {
      cellphone,
      smsCode,
    },
    false
  );
  return res;
}
/**
 * 登录接口
 * @param userName  姓名
 * @param password  密码
 * @param code  验证码
 * @param uuid  uuid
 */
export async function login(param: any) {
  const res = await post(`${prefixpath}/dev-api/auth/login`, param, false);
  return res;
}
/**
 * 退出登录
 */
export async function queryLogOut() {
  const res = await del(`${prefixpath}/dev-api/auth/logout`, {}, false);
  return res;
}
/**
 * 注册接口
 */
export async function queryRegister(param: any) {
  const res = await post(`${prefixpath}/dev-api/auth/register`, param, false);
  return res;
}
/**
 * banner信息存在，补全接口
 */
export async function queryReportConfirm(param: any) {
  const res = await put(
    `${prefixpath}/dev-api/system/user/reportConfirm`,
    param,
    false
  );
  return res;
}
/**
 * banner信息不存在,注册接口
 */
export async function queryReportRegister(param: any) {
  const res = await post(
    `${prefixpath}/dev-api/system/user/reportRegister`,
    param,
    false
  );
  return res;
}
/**
 * 登录信息不全补全接口
 */
export async function reportConfirm(param: any) {
  const res = await put(
    `${prefixpath}/dev-api/system/user/confirm`,
    param,
    false
  );
  return res;
}
/**
 * 获取用户userId
 */
export async function getUserInfo() {
  const res = await get(`${prefixpath}/dev-api/system/user/getInfo`, {}, false);
  return res;
}
/**
 * 获取用户信息详情
 */
export async function getUserInfoByUserId(userId: number) {
  const res = await get(
    `${prefixpath}/dev-api/system/userInstitute/user?userId=${userId}`,
    {},
    false
  );
  return res;
}
/**
 * 更新用户信息
 */
export async function updateUserInfo(param: UserDetailInfoProps) {
  const res = await put(`${prefixpath}/dev-api/system/user`, param, false);
  return res;
}
/**
 * 更新用户角色
 */
export async function updateUserRole(roleId: string) {
  const res = await put(
    `${prefixpath}/dev-api/system/user/baseUserCategory?roleId=${roleId}`,
    {},
    false
  );
  return res;
}
/**
 * 修改用户密码
 */
export async function updatePassWord({
  userId,
  pwd,
  oldPwd,
}: {
  userId: number | null;
  pwd: string;
  oldPwd: string;
}) {
  const res = await put(
    `${prefixpath}/dev-api/system/user/updatePwd`,
    { userId, pwd, oldPwd },
    false
  );
  return res;
}
/**
 * 获取首页课程
 */
export async function getCourseList(
  searchValue: string,
  pageData: {
    pageNum: number;
    pageSize: number;
  }
) {
  const { pageNum, pageSize } = pageData;
  const res = await post(
    `${prefixpath}/dev-api/learn/front/index/course/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    {
      searchValue,
      ...pageData,
    },
    false
  );
  return res;
}
/**
 * 获取学科数据
 */
export async function getSubjectList() {
  const res = await get(
    `${prefixpath}/dev-api/system/subject/list?parentId=0`,
    {},
    false
  );
  return res;
}
/**
 * 获取培训课程数据
 */
export async function getTrainCourseList(
  param: any,
  page: {
    pageNum: number;
    pageSize: number;
  }
) {
  const { pageNum, pageSize } = page;
  const res = await post(
    `${prefixpath}/dev-api/learn/front/train/course/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    param,
    false
  );
  return res;
}
/**
 * 获取专项课程数据
 */
export async function getCategroyCourseList(
  param: any,
  page: {
    pageNum: number;
    pageSize: number;
  }
) {
  const { pageNum, pageSize } = page;
  const res = await post(
    `${prefixpath}/dev-api/learn/front/special/course/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    param,
    false
  );
  return res;
}
/**
 * 根据省份获取医院列表
 */
export async function getHospitalListByProvinceCode(codeList: string[]) {
  const [provinceCode, cityCode] = codeList;
  const res = await get(
    `${prefixpath}/dev-api/system/institute/list?provinceCode=${provinceCode}&cityCode=${cityCode}`,
    {},
    false
  );
  return res;
}
/**
 * 获取机构列表
 */
export async function getInstituteList(name: any) {
  const url = `${prefixpath}/dev-api/system/institute/list?pageNum=${1}&pageSize=${100}${
    name ? `&name=${name}` : ""
  }`;
  const res = await get(url, {}, false);
  return res;
}
/**
 * 获取机构列表新版
 */
export async function getInstituteList_new() {
  const res = await get(
    `${prefixpath}/dev-api/system/institute/pulllist?isInit=2`,
    {},
    false
  );
  return res;
}
/**

/**
 * 新增国家批次
 */
export async function addBatch(param: any) {
  const res = await post(`${prefixpath}/dev-api/system/batch`, param, false);
  return res;
}
/**
 * 获取国家批次列表
 */
export async function getBatch() {
  const res = await get(`${prefixpath}/dev-api/system/batch/list`, {}, false);
  return res;
}
/**
 * 国家批次修改
 */
export async function updateBatch(param: any) {
  const res = await put(`${prefixpath}/dev-api/system/batch`, param, false);
  return res;
}
/**
 * 获取省批次列表
 */
export async function getProvinceBatch(param: any) {
  const res = await get(
    `${prefixpath}/dev-api/system/provincebatch/list?year=${
      param.year
    }&batchNumber=${param.batch}&provicneCode=${
      param.province
    }&pageNum=${1}&pageSize=${10000}`,
    {},
    false
  );
  return res;
}
/**
 * 省批次修改
 */
export async function updateProvinceBatch(param: any) {
  const res = await put(
    `${prefixpath}/dev-api/system/provincebatch`,
    param,
    false
  );
  return res;
}
/**
 * 获取机构次列表
 */
export async function getCountyBatch(param: any) {
  const res = await get(
    `${prefixpath}/dev-api/system/hospitalbatch/list?year=${
      param.year
    }&batchNumber=${param.batch}&provicneCode=${param.province}&instituteName=${
      param.institute
    }&pageNum=${1}&pageSize=${10000}`,
    {},
    false
  );
  return res;
}
/**
 * 机构批次修改
 */
export async function updateCountyBatch(param: any) {
  const res = await put(
    `${prefixpath}/dev-api/system/hospitalbatch`,
    param,
    false
  );
  return res;
}
/**
 * 获取机构次列表
 */
export async function getHelpRelation(param: any) {
  const res = await get(
    `${prefixpath}/dev-api/system/adjust/page?${param}&pageNum=${1}&pageSize=${10000}`,
    {},
    false
  );
  return res;
}
/**
 * 修改帮扶关系国家确认状态
 */
export async function setAuditConfirm(param: any) {
  const res = await put(
    `${prefixpath}/dev-api/system/adjust/audit`,
    param,
    false
  );
  return res;
}
/**
 * 帮扶关系流程新增
 */
export async function addHelpRelation(param: any) {
  const res = await post(`${prefixpath}/dev-api/system/adjust`, param, false);
  return res;
}
/**
 * 帮扶关系流程修改
 */
export async function setHelpRelation(param: any) {
  const res = await put(`${prefixpath}/dev-api/system/adjust`, param, false);
  return res;
}
/**
 * 修改帮扶关系三级/支援医院确认状态
 */
export async function setConfirm(param: any) {
  const res = await put(
    `${prefixpath}/dev-api/system/adjust/confirm`,
    param,
    false
  );
  return res;
}
/**
 * 获取机构信息
 */
export async function getHospitalBatch(param: any) {
  const res = await get(
    `${prefixpath}/dev-api/system/hospitalbatch/use?instituteId=${param.instituteId}`,
    {},
    false
  );
  return res;
}
/**
 * 查询帮扶学科确认
 */
export async function getHelpObject(param: any) {
  const res = await get(
    `${prefixpath}/dev-api/system/confirm/list?${param}`,
    {},
    false
  );
  return res;
}
/**
 * 帮扶关系分页列表查询
 */
export async function getHelpRelat(param: any) {
  const res = await get(
    `${prefixpath}/dev-api/system/relation/page?recipientInstituteId=${
      param.recipientInstituteId
    }&pageNum=${1}&pageSize=${10000}`,
    {},
    false
  );
  return res;
}
/**
 * 修改帮扶学科确认学科
 */
export async function setHelpObject(param: any) {
  const res = await put(
    `${prefixpath}/dev-api/system/confirm/subject`,
    param,
    false
  );
  return res;
}
/**
 * 帮扶关系流程上报状态批量修改
 */
export async function setAdjustSubmit(param: any) {
  const res = await put(
    `${prefixpath}/dev-api/system/adjust/submit?ids=${param.ids}&status=${param.status}`,
    {},
    false
  );
  return res;
}
/**
 * 修改帮扶学科确认上报状态
 */
export async function setHelpSubmit(param: any) {
  const res = await put(
    `${prefixpath}/dev-api/system/confirm/submit?ids=${param.ids}&status=${param.status}`,
    {},
    false
  );
  return res;
}
/**
 * 修改帮扶学科确认三级确认状态
 */
export async function setHelpConfirm(param: any) {
  const res = await put(
    `${prefixpath}/dev-api/system/confirm/confirm`,
    param,
    false
  );
  return res;
}

/**
 * 获取课程学习信息
 * @param id 课程Id
 * @returns
 */
export async function getCourseLearnInfo(id: number) {
  const res = await post(
    `${prefixpath}/dev-api/learn/front/course/${id}/learn`,
    {},
    false
  );
  return res;
}
/**
 * 获取权限菜单
 * @param userName  姓名
 * @param password  密码
 * @param code  验证码
 * @param uuid  uuid
 */
export async function getAuthMenuData() {
  const res = await get(
    `${prefixpath}/dev-api/system/menu/getRouters?device=PC`,
    {},
    false
  );
  return res;
}
/**
 * 保存观看
 * @param param  视频参数
 * @param videoType 视频类型
 */
export async function querySaveWatchRecord(param: any) {
  const url = `${prefixpath}/dev-api/learn/record/update`;
  return await post(url, param, false);
}
/**
 * 防多开
 */
export async function queryPreventOpenMoreVideo(param: any) {
  return await post(`${prefixpath}/dev-api/learn/record/update`, param, false);
}

/**
 * 查询讲师列表
 */
export async function teacherList(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/teacher/list?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 文件上传到OSS
 */
export async function uploadFile(param: any) {
  return await upload(
    `${prefixpath}/dev-api/file/oss/uploadFile`,
    param,
    false
  );
}

/**
 * 根据一个图片文件得到其Base64格式文件数据
 */
export async function getBase64Image(param: any) {
  return await post(
    `${prefixpath}/dev-api/file/getBase64Image?imagePath=${param}`,
    {},
    false
  );
}

/**
 * BASE64图片上传到OSS
 */
export async function uploadBase64Image(param: any) {
  return await upload(
    `${prefixpath}/dev-api/file/oss/uploadBase64Image`,
    param,
    false
  );
}

/**
 * 新增讲师
 */
export async function addTeacher(param: any) {
  return await post(`${prefixpath}/dev-api/learn/teacher/add`, param, false);
}

/**
 * 获取讲师详细信息
 */
export async function getTeacher(param: any) {
  return await get(`${prefixpath}/dev-api/learn/teacher/${param}`, {}, false);
}

/**
 * 修改讲师
 */
export async function updateTeacher(param: any) {
  return await post(`${prefixpath}/dev-api/learn/teacher/update`, param, false);
}

/**
 * 删除讲师
 */
export async function deleteTeacher(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/teacher/delete/${param}`,
    param,
    false
  );
}

export async function selectTeacher() {
  return await get(
    `${prefixpath}/dev-api/learn/teacher/select/list`,
    {},
    false
  );
}

/**
 * 创建视频上传信息
 */
export async function uploadVideo(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/video/create/upload/info`,
    param,
    false
  );
}

/**
 * 保存视频信息(用于上传视频成功后)
 */
export async function saveVideo(param: any) {
  return await post(`${prefixpath}/dev-api/learn/video/save`, param, false);
}

/**
 * 视频分页列表
 */
export async function getVideoList(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/video/list?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 得到视频信息(用于视频编辑)
 */
export async function videoInfo(param: any) {
  return await get(
    `${prefixpath}/dev-api/learn/video/info/${param}`,
    {},
    false
  );
}

/**
 * 更新视频信息(用于视频编辑)
 */
export async function updateVideo(param: any) {
  return await post(`${prefixpath}/dev-api/learn/video/update`, param, false);
}

/**
 * 选择视频分页列表(用于课程中选择视频
 */
export async function selectVideo(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/video/select/list?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 新增标签
 */
export async function addTag(param: any) {
  return await post(`${prefixpath}/dev-api/learn/tag/add`, param, false);
}

/**
 * 标签分页列表
 */
export async function getTagList(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/tag/list?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 新增标签
 */
export async function updateTag(param: any) {
  return await post(`${prefixpath}/dev-api/learn/tag/update`, param, false);
}

/**
 * 启用或停用标签
 */
export async function statusTag(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/tag/update/status`,
    param,
    false
  );
}

/**
 * 删除标签
 */
export async function deleteTag(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/tag/delete/${param}`,
    param,
    false
  );
}

/**
 * 获取标签详细信息
 */
export async function getTag(param: any) {
  return await get(`${prefixpath}/dev-api/learn/tag/${param}`, {}, false);
}

/**
 * 获取标签详细信息
 */
export async function selectTag() {
  return await get(`${prefixpath}/dev-api/learn/tag/select/list`, {}, false);
}

/**
 * 保存课程
 */
export async function saveCourse(param: any) {
  return await post(`${prefixpath}/dev-api/learn/course/save`, param, false);
}
/**
 * 保存直播
 */
export async function saveLive(param: any) {
  return await post(`${prefixpath}/dev-api/learn/live/save`, param, false);
}

/**
 * 课程分页列表
 */
export async function courseList(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/course/list?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 课程分页列表
 */
export async function liveList(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/live/list?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 课程详情信息
 */
export async function courseInfo(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/course/${param}/info`,
    {},
    false
  );
}
/**
 * 直播详情信息
 */
export async function liveInfo(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/live/${param}/info`,
    {},
    false
  );
}

/**
 * (批量)修改上下架状态
 */
export async function courseStatus(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/course/status/update`,
    param,
    false
  );
}
/**
 * (批量)修改直播上下架状态
 */
export async function liveStatus(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/live/status/update`,
    param,
    false
  );
}
/**
 * 课程预览
 */
export async function coursePreview(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/course/${param}/preview`,
    {},
    false
  );
}

/**
 * 删除课程
 */
export async function courseDelete(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/course/${param}/delete`,
    {},
    false
  );
}
/**
 * 删除直播
 */
export async function liveDelete(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/live/${param}/delete`,
    {},
    false
  );
}

/**
 * 根据CC创建课程
 */
export async function courseVideo(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/course/create/video/course/${param}`,
    {},
    false
  );
}

/**
 * 得到学习设置
 */
export async function ruleInfo() {
  return await get(`${prefixpath}/dev-api/learn/rule/info`, {}, false);
}

/**
 * 修改学习设置
 */
export async function ruleUpdate(param: any) {
  return await post(`${prefixpath}/dev-api/learn/rule/update`, param, false);
}

/**
 * 课程统计-按国家查询
 */
export async function countryView(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/course/country/course/tag/view?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 课程统计-按国家查询_导出
 */
export async function countryExport(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/course/country/course/tag/view/export`,
    param,
    false,
    true
  );
}

/**
 * 学习概况
 */
export async function getUserLearn() {
  return await post(
    `${prefixpath}/dev-api/learn/front/user/learn/view`,
    {},
    false
  );
}

/**
 * 获取当前正在学习的课程
 */
export async function getLearnCourseList<T extends pageProps>({
  pageNum,
  pageSize,
}: T) {
  return await post(
    `${prefixpath}/dev-api/learn/front/my/learn/course/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    {},
    false
  );
}
/**
 * 获取已完成的学习课程
 */
export async function getFinshLearnCourseList<T extends pageProps>({
  pageNum,
  pageSize,
}: T) {
  return await post(
    `${prefixpath}/dev-api/learn/front/my/finish/course/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    {},
    false
  );
}
/**
 * 正在学习的临床课程
 */
export async function getLearnClinicCourseList<T extends pageProps>({
  pageNum,
  pageSize,
}: T) {
  return await post(
    `${prefixpath}/dev-api/learn/front/my/learn/clinic/course/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    {},
    false
  );
}
/**
 * 已完成学习的临床课程
 */
export async function getFinishClinicCourseList<T extends pageProps>({
  pageNum,
  pageSize,
}: T) {
  return await post(
    `${prefixpath}/dev-api/learn/front/my/finish/clinic/course/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    {},
    false
  );
}
/**
 * 正在学习的专项课程
 */
export async function getLearnSpecialCourseList<T extends pageProps>({
  pageNum,
  pageSize,
}: T) {
  return await post(
    `${prefixpath}/dev-api/learn/front/my/learn/special/course/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    {},
    false
  );
}
/**
 * 已完成学习的专项课程
 */
export async function getFinishSpecialCourseList<T extends pageProps>({
  pageNum,
  pageSize,
}: T) {
  return await post(
    `${prefixpath}/dev-api/learn/front/my/finish/special/course/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    {},
    false
  );
}
/**
 * 获取待学习的学习课程
 */
export async function getUnLearnCourseList<T extends pageProps>({
  pageNum,
  pageSize,
}: T) {
  return await post(
    `${prefixpath}/dev-api/learn/front/my/unlearn/course/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    {},
    false
  );
}
/**
 * 县医院待审核流程列表
 */
export async function getVillageWaitReviewedList<T extends pageProps>(
  { pageNum, pageSize }: T,
  param: any
) {
  return await get(
    `${prefixpath}/dev-api/system/userInstitute/list?pageNum=${pageNum}&pageSize=${pageSize}${
      param ? param : ""
    }&orderByColumn=update_time&isAsc=desc`,
    {},
    false
  );
}
/**
 * 县医院审核状态修改
 */
export async function updateUserInstituteStatus(param: any) {
  return await put(
    `${prefixpath}/dev-api/system/userInstitute/status`,
    param,
    false
  );
}
/**
 * 获取用户调出列表
 */
export async function getOutlog(param: any) {
  return await get(
    `${prefixpath}/dev-api/system/outlog/list?${param}`,
    {},
    false
  );
}
/**
 * 用户调出导出
 */
export async function exportOutlog(param: any) {
  return await post(
    `${prefixpath}/dev-api/system/outlog/export?instituteId=${param.instituteId}`,
    param,
    false
  );
}
/**
 * 获取用户培训管理列表
 */
export async function getTrain(param: any) {
  return await get(
    `${prefixpath}/dev-api/system/user/page?${param}&pageNum=1&pageSize=1000&orderByColumn=u.create_time&isAsc=desc`,
    {},
    false
  );
}
/**
 * 获取用户模板下载
 */
export async function getTemplate() {
  return await get(
    `${prefixpath}/dev-api/system/template/list?exceltemplatetypecode=stu_template`,
    {},
    false
  );
}
/**
 * 重置密码
 */
export async function resetPassword(param: any) {
  return await put(`${prefixpath}/dev-api/system/user/resetPwd`, param, false);
}
/**
 * 修改用户状态
 */
export async function setStatus(param: any) {
  return await put(
    `${prefixpath}/dev-api/system/user/out/${param.userId}?status=${param.status}`,
    {},
    false
  );
}
/**
 * 用户列表导出
 */
export async function exportUser(param: any) {
  return await post(`${prefixpath}/dev-api/system/user/export`, param, false);
}
/**
 * 修改机构用户录入方式
 */
export async function setUserImport(param: any) {
  return await put(
    `${prefixpath}/dev-api/system/institute/editreg/${param.instituteId}?status=${param.status}`,
    {},
    false
  );
}
/**
 * 获取三级医院的机构
 */
export async function getThreeInstitute() {
  return await get(
    `${prefixpath}/dev-api/system/institute/list?isThree=0`,
    {},
    false
  );
}
/**
 * 获取全国级统计数据
 */
export async function getCountryLearnView(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/global/country/learn/view`,
    param,
    false
  );
}
/**
 * 获取全国级分布信息
 */
export async function getCountryLearnEchartData(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/global/country/learn/map/view`,
    param,
    false
  );
}
/**
 * 获取全国级支援医院数量
 */
export async function getCountryHospitalDataManage(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/data/country/hospital/data/view`,
    params,
    false
  );
}
/**
 * 国家的支援和受援医院数量_导出
 */
export async function exportCountryHospitalDataManage() {
  return await post(
    `${prefixpath}/dev-api/learn/data/country/hospital/data/export`,
    {},
    false,
    true
  );
}
/**
 * 获取国家注册和学习人数
 */
export async function getCountryUserDataManage(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/data/country/user/data/view`,
    params,
    false
  );
}
/**
 * 国家的注册和学习人数_导出
 */
export async function exportCountryUserDataManage() {
  return await post(
    `${prefixpath}/dev-api/learn/data/country/user/data/export`,
    {},
    false,
    true
  );
}
/**
 * 获取国家培训率
 */
export async function getCountryTrainDataManage(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/data/country/train/data/view`,
    params,
    false
  );
}
/**
 * 国家的培训率_导出
 */
export async function exportCountryTrainDataManage() {
  return await post(
    `${prefixpath}/dev-api/learn/data/country/train/data/export`,
    {},
    false,
    true
  );
}
/**
 * 获取省级支援医院数量
 */
export async function getProvinceHospitalDataManage(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/data/province/hospital/data/view`,
    params,
    false
  );
}
/**
 * 获取省注册和学习人数
 */
export async function getProvinceUserDataManage(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/data/province/user/data/view`,
    params,
    false
  );
}
/**
 * 获取省培训率
 */
export async function getProvinceTrainDataManage(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/data/province/train/data/view`,
    params,
    false
  );
}
/**
 * 获取省级统计数据
 */
export async function getProvinceLearnView(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/global/province/learn/view`,
    params,
    false
  );
}
/**
 * 获取市的学习时长和平均学习时长
 */
export async function getCityUserDataManage(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/data/city/watch/time/view`,
    params,
    false
  );
}
/**
 * 获取市注册和学习人数
 */
export async function getCityTrainDataManage(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/data/city/user/data/view`,
    params,
    false
  );
}
/**
 * 获取市级培训率
 */
export async function getCityceLearnView(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/data/city/train/data/view`,
    params,
    false
  );
}
/**
 * 获取支援医院的学习时长和平均时长
 */
export async function getSupportUserDataManage(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/data/supportHospital/watch/time/view`,
    params,
    false
  );
}
/**
 * 获取支援医院帮扶学员和学习人数
 */
export async function getSupportLearnView(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/data/supportHospital/user/data/view`,
    params,
    false
  );
}
/**
 * 获取支援培训率
 */
export async function getSupportTrainDataManage(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/data/supportHospital/train/data/view`,
    params,
    false
  );
}
/**
 * 获取受援医院的学习时长和平均时长
 */
export async function getRecipientUserDataManage(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/data/recipientHospital/watch/time/view`,
    params,
    false
  );
}
/**
 * 受援医院学习时长和平均学习时长_导出
 */
export async function exportRecipientUserDataManage() {
  return await post(
    `${prefixpath}/dev-api/learn/data/recipientHospital/watch/time/export`,
    {},
    false,
    true
  );
}
/**
 * 获取受援医院帮扶学员和学习人数
 */
export async function getRecipientLearnView(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/data/recipientHospital/user/data/view
    `,
    params,
    false
  );
}
/**
 * 受援医院注册人数和人数_导出
 */
export async function exportRecipientLearnView() {
  return await post(
    `${prefixpath}/dev-api/learn/data/recipientHospital/user/data/export`,
    {},
    false,
    true
  );
}
/**
 * 获取受援培训率
 */
export async function getRecipientTrainDataManage(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/data/recipientHospital/train/data/view`,
    params,
    false
  );
}
/**
 * 受援医院培训率_导出
 */
export async function exportRecipientTrainDataManage() {
  return await post(
    `${prefixpath}/dev-api/learn/data/recipientHospital/train/data/export`,
    {},
    false,
    true
  );
}
/**
 * 获取省级分布信息
 */
export async function getProvinceLearnEchartData(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/global/province/learn/map/view`,
    params,
    false
  );
}
/**
 * 获取市级统计数据
 */
export async function getCityLearnView(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/global/city/learn/view`,
    params,
    false
  );
}
/**
 * 获取支援统计数据
 */
export async function getSupportHospitalLearnView(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/global/supportHospital/learn/view`,
    params,
    false
  );
}
/**
 * 获取受援统计数据
 */
export async function getRecipientHospitalLearnView(params: any) {
  return await post(
    `${prefixpath}/dev-api/learn/global/recipientHospital/learn/view`,
    params,
    false
  );
}
/**
 * 获取客服信息和联系电话
 */
export async function getSystemDescriptionLsit() {
  return await get(`${prefixpath}/dev-api/system/description/list`, {}, false);
}
/**
 * 登录注册机构查询
 */
export async function getRegisterInstituteList(code: string) {
  return await get(
    `${prefixpath}/dev-api/system/institute/list?isCounty=0&districtCode=${code}`,
    {},
    false
  );
}

/**
 * 省级课程审核分页列表
 */
export async function getCourseAuditList(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/course/audit/list?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 得到课程的汇总信息
 */
export async function getCourseSummaryInfo() {
  return await post(
    `${prefixpath}/dev-api/learn/course/summary/info`,
    {},
    false
  );
}
/**
 * 得到直播的汇总信息
 */
export async function getLiveSummaryInfo() {
  return await post(`${prefixpath}/dev-api/learn/live/summary/info`, {}, false);
}
/**
 * 得到课程的审核汇总信息
 */
export async function getCourseAuditInfo() {
  return await post(`${prefixpath}/dev-api/learn/course/audit/info`, {}, false);
}

/**
 * 取消课程审核通过
 */
export async function auditPass(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/course/cancel/audit/pass`,
    param,
    false
  );
}

/**
 * 修改课程审核状态(批量通过，批量驳回，审核通过，审核驳回)
 */
export async function auditUpdate(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/course/audit/status/update`,
    param,
    false
  );
}

/**
 * 得到视频空间相关信息
 */
export async function spaceInfo() {
  return await post(`${prefixpath}/dev-api/learn/video/space/info`, {}, false);
}
/**
 * 获取审批流程详情
 */
export async function queryApprovalInfo(flowId: number) {
  return await get(
    `${prefixpath}/dev-api/system/info/list?flowId=${flowId}`,
    {},
    false
  );
}

/**
 * 国家级课程按标签分类统计
 */
export async function statisticsOfTag(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/country/course/tag/view?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 国家级课程按标签分类统计导出
 */

export async function exportStatisticsOfTag(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/country/course/tag/view/export` + param,
    param,
    false,
    true
  );
}

/**
 * 国家级按课程标签和课程类型统计
 */
export async function statisticsOfType(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/country/course/tag/type/view?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 国家级按课程标签和课程类型统计导出
 */
export async function exportStatisticsOfType(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/country/course/tag/type/view/export` + param,
    param,
    false,
    true
  );
}

/**
 * 国家级按省统计课程
 */
export async function statisticsOfProince(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/country/course/province/view?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 国家级按省统计课程导出
 */
export async function exportStatisticsOfProince(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/country/course/province/view/export${param}`,
    param,
    false,
    true
  );
}

/**
 * 国家级按省和市统计课程
 */
export async function statisticsOfCity(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/country/course/province/city/view?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 国家级按省和市统计课程导出
 */
export async function exportStatisticsOfCity(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/country/course/province/city/view/export${param}`,
    param,
    false,
    true
  );
}

/**
 * 国家级按医院统计课程
 */
export async function statisticsOfHospital(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/country/course/hospital/view?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 国家级按医院统计课程导出
 */
export async function exportStatisticsOfHospital(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/country/course/hospital/view/export${param}`,
    param,
    false,
    true
  );
}

/**
 * 国家级按学科统计课程
 */
export async function statisticsOfSubject(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/country/course/subject/view?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 国家级按学科统计课程导出
 */
export async function exportStatisticsOfSubject(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/country/course/subject/view/export${param}`,
    param,
    false,
    true
  );
}

/**
 * 国家级按中心统计课程
 */
export async function statisticsOfCenter(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/country/course/center/view?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 国家级按中心统计课程导出
 */
export async function exportStatisticsOfCenter(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/country/course/center/view/export${param}`,
    param,
    false,
    true
  );
}

/**
 * 省级按医院统计课程
 */
export async function statisticsOfHospitalOnProvince(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/province/course/hospital/view?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 省级按医院统计课程导出
 */
export async function exportStatisticsOfHospitalOnProvince(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/province/course/hospital/view/export${param}`,
    param,
    false,
    true
  );
}

/**
 * 省级按学科统计课程
 */
export async function statisticsOfSubjectOnProvince(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/province/course/subject/view?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 省级按学科统计课程导出
 */
export async function exportStatisticsOfSubjectOnProvince(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/province/course/subject/view/export${param}`,
    param,
    false,
    true
  );
}

/**
 * 市级按医院统计课程
 */
export async function statisticsOfHospitalOnCity(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/city/course/hospital/view?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 市级按医院统计课程导出
 */
export async function exportStatisticsOfHospitalOnCity(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/city/course/hospital/view/export${param}`,
    param,
    false,
    true
  );
}

/**
 * 市级按学科统计课程
 */
export async function statisticsOfSubjectOnCity(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/city/course/subject/view?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 市级按医院统计课程导出
 */
export async function exportStatisticsOfSubjectOnCity(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/city/course/subject/view/export${param}`,
    param,
    false,
    true
  );
}

/**
 * 支援医院按学科统计课程
 */
export async function statisticsOfSubjectlOnSupport(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/supportHospital/course/subject/view?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 支援医院按学科统计课程导出
 */
export async function exportStatisticsOfSubjectOnSupport(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/supportHospital/course/subject/view/export${param}`,
    param,
    false,
    true
  );
}

/**
 * 受援医院按学科统计课程
 */
export async function statisticsOfSubjectlOnRecipient(page: any, param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/recipientHospital/course/subject/view?pageNum=${page.pageNum}&pageSize=${page.pageSize}`,
    param,
    false
  );
}

/**
 * 受援医院按学科统计课程导出
 */
export async function exportStatisticsOfSubjectlOnRecipient(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/recipientHospital/course/subject/view/export${param}`,
    param,
    false,
    true
  );
}

/**
 * 得到国家中心机构列表
 */
export async function getCenterList(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/country/center/list`,
    param,
    false
  );
}

/**
 * 机构课程学科列表(与本机构创建课程有关联的学科)
 */
export async function getInstituteSubjectList(param: any) {
  return await post(
    `${prefixpath}/dev-api/learn/course/institute/subject/list`,
    param,
    false
  );
}
/**
 * 获取管理员管理页面数据
 */
export async function getAdminManageData(pageNum: number, str: string = "") {
  return await get(
    `${prefixpath}/dev-api/system/user/admin/page?pageNum=${pageNum}&pageSize=${10}${str}`,
    {},
    false
  );
}
/**
 * 新增管理员
 */
export async function queryAddCountyAdmin(data: any) {
  return await post(`${prefixpath}/dev-api/system/user/admin`, data, false);
}
/**
 * 管理员管理
 */
export async function getAdminTemplate() {
  return await get(
    `${prefixpath}/dev-api/system/template/list?exceltemplatetypecode=admin_template`,
    {},
    false
  );
}
/**
 * 删除管理员管理
 */
export async function queryDeleteUserAdmin(userId: number) {
  return await del(
    `${prefixpath}/dev-api/system/user/admin?userId=${userId}`,
    {},
    false
  );
}
/**
 * 更新管理员信息
 * @param data 管理员信息
 * @returns
 */
export async function queryUpdateCountyAdmin(data: any) {
  return await put(`${prefixpath}/dev-api/system/user/admin`, data, false);
}
/**
 * 获取专项分类tree数据
 * @returns
 */
export async function querySpecialClassificationData() {
  return await post(`${prefixpath}/dev-api/learn/category/list`, {}, false);
}
/**
 * 获取直播专项分类tree数据(用于后端)
 * @returns
 */
export async function querySpecialClassificationDataByLiveWeb() {
  return await post(
    `${prefixpath}/dev-api/learn/live/category/list/info`,
    {},
    false
  );
}
/**
 * 获取直播专项分类tree数据(用于后端)
 * @returns
 */
export async function querySpecialClassificationDataByLive() {
  return await post(
    `${prefixpath}/dev-api/learn/live/category/list`,
    {},
    false
  );
}
/**
 * 根据分类Id得到分类信息
 * @param treeId
 * @returns
 */
export async function queryCategoryDataByTreeId(treeId: number) {
  return await post(
    `${prefixpath}/dev-api/learn/category/${treeId}`,
    {},
    false
  );
}
/**
 * 得到专项根节点和一级分类列表
 */
export async function queryCategoryParentList() {
  return await post(
    `${prefixpath}/dev-api/learn/category/parent/list`,
    {},
    false
  );
}
/**
 * 得到直播专项根节点和一级分类列表
 */
export async function queryCategoryParentListByLive() {
  return await post(
    `${prefixpath}/dev-api/learn/live/category/parent/list`,
    {},
    false
  );
}
/**
 * 新增/编辑专项分类
 */
export async function querySaveCategoryData(data: any) {
  return await post(`${prefixpath}/dev-api/learn/category/save`, data, false);
}
/**
 * 新增/编辑直播专项分类
 */
export async function querySaveCategoryDataByLive(data: any) {
  return await post(
    `${prefixpath}/dev-api/learn/live/category/save`,
    data,
    false
  );
}
/**
 * 删除专项分类
 */
export async function queryDeleteCategoryById(id: number) {
  return await post(
    `${prefixpath}/dev-api/learn/category/${id}/delete
  `,
    {},
    false
  );
}
/**
 * 删除直播专项分类
 */
export async function queryDeleteLiveCategoryById(id: number) {
  return await post(
    `${prefixpath}/dev-api/learn/live/category/${id}/delete
  `,
    {},
    false
  );
}
/**
 * 获取专项列表(前端用)
 */
export async function queryLearnCategoryListInfo() {
  return await post(
    `${prefixpath}/dev-api/learn/category/list/info
  `,
    {},
    false
  );
}
/**
 * 提交用户评论
 */
export async function queryAddUserCommet(param: any) {
  return await post(
    `${prefixpath}/dev-api/system/comment
  `,
    param,
    false
  );
}
/**
 * 通过镇获取乡
 */
export async function queryCountryListByTownId(parentId: string) {
  return await get(
    `${prefixpath}/dev-api/system/country/list?parent=${parentId}
  `,
    {},
    false
  );
}
/**
 * 通过乡获取村
 */
export async function queryVillageByCountryId(parentId: string) {
  return await get(
    `${prefixpath}/dev-api/system/village/list?parent=${parentId}
  `,
    {},
    false
  );
}
/**
 * 确认信息接口
 */
export async function querySystemUserConfirm(param: any) {
  return await put(
    `${prefixpath}/dev-api/system/user/confirm
  `,
    param,
    false
  );
}
/**
 * 获取首页菜单
 */
export async function getHomemMenus(): Promise<Result<HomeMenu[]>> {
  const res = await get(`${prefixpath}/dev-api/news/column/home`, {}, false);
  return res;
}
/**
 * 获取首页(门户页)各模块
 */
export async function getHomemMoudles(): Promise<Result<HomeMoules>> {
  const res = await get(`${prefixpath}/dev-api/news/news/home`, {}, false);
  return res;
}
/**
 * 获取新闻列表
 */
export async function getNewsList(
  secondColumn: number,
  pageNum: number,
  pageSize: number = 5
): Promise<ResultList<NewsItem[]>> {
  const res = await get(
    `${prefixpath}/dev-api/news/news/list?secondColumn=${secondColumn}&pageSize=${pageSize}&pageNum=${pageNum}`,
    {},
    false
  );
  return res;
}
/**
 * 获取新闻详情
 */
export async function getNewsDetail(newsId: number): Promise<Result<NewsItem>> {
  const res = await get(`${prefixpath}/dev-api/news/news/${newsId}`, {}, false);
  return res;
}
/**
 * 点击新增阅读数
 */
export async function addNewsDetailsPV(
  newsId: number
): Promise<Result<string>> {
  const res = await get(
    `${prefixpath}/dev-api/news/news/add/${newsId}`,
    {},
    false
  );
  return res;
}

//新闻编辑接口 ↓↓↓↓↓↓↓↓

/**
 * 新闻->创建账号->获取机构信息列表
 */
export async function getNewsEditList(code: string) {
  const res = get(`${prefixpath}/dev-api/system/user/list?${code}`, {}, false);
  return res;
}

/**
 * 新闻->创建账号->新增用户角色
 */
export async function addNewsUser(params: any) {
  const res = post(`${prefixpath}/dev-api/system/user`, params, false);
  return res;
}

/**
 * 新闻->创建账号->修改编辑用户角色
 */
export async function setNewsUser(params: any) {
  const res = put(`${prefixpath}/dev-api/system/user/editor`, params, false);
  return res;
}

/**
 * 新闻->创建账号->删除编辑用户角色
 */
export async function delNewsUser(code: string | number) {
  const res = del(
    `${prefixpath}/dev-api/system/user/editor?userId=${code}`,
    {},
    false
  );
  return res;
}

/**
 * 新闻->创建账号->重置用户角色密码
 */
export async function resetNewsUserPwd(params: any) {
  const res = put(
    `${prefixpath}/dev-api/system/user/admin/resetPwd`,
    params,
    false
  );
  return res;
}

/**
 * 新闻->创建账号->导入
 */
export async function importNewsUser(params: any) {
  const res = post(
    `${prefixpath}/dev-api/system/user/editor/importData`,
    params,
    false
  );
  return res;
}

/**
 * 新闻->创建账号->下载模板
 */
export async function downloadNewsExcel() {
  const res = get(
    `${prefixpath}/dev-api/system/template/list?exceltemplatetypecode=admin_template`,
    {},
    false
  );
  return res;
}

//一级栏目二级栏目接口 ↓↓↓↓↓↓↓↓
/**
 * 一级栏目->获取表格数据
 */
export async function getLevelList(code: string) {
  const res = get(`${prefixpath}/dev-api/news/column/list?${code}`, {}, false);
  return res;
}

/**
 * 栏目->新增
 */
export async function addLevel(params: any) {
  const res = post(`${prefixpath}/dev-api/news/column`, params, false);
  return res;
}

/**
 * 栏目->修改
 */
export async function setLevel(params: any) {
  const res = put(`${prefixpath}/dev-api/news/column`, params, false);
  return res;
}

/**
 * 栏目->删除
 */
export async function delLevel(code: string | number) {
  const res = del(`${prefixpath}/dev-api/news/column/${code}`, {}, false);
  return res;
}

//运营新闻 ↓↓↓↓↓↓↓↓
/**
 * 新闻->获取表格数据
 */
export async function getPublishNews(code: string | number) {
  const res = get(`${prefixpath}/dev-api/news/news/operate?${code}`, {}, false);
  return res;
}

/**
 * 新闻->设置上下架
 */
export async function setNewsShelf(params: any) {
  const res = put(`${prefixpath}/dev-api/news/news/publish`, params, false);
  return res;
}

/**
 * 新闻->编辑排序
 */
export async function setSortEdit(params: any) {
  const res = put(`${prefixpath}/dev-api/news/news/edit/order`, params, false);
  return res;
}

/**
 * 新闻->获取新闻表格数据
 */
export async function getEditNews(code: string | number) {
  const res = get(`${prefixpath}/dev-api/news/news/page?${code}`, {}, false);
  return res;
}

/**
 * 各种类型文件上传到OSS
 */
export async function uploadFileAll(param: any) {
  return await upload(
    `${prefixpath}/dev-api/file/oss/uploadFile?uploadFileType=file&folder=sys`,
    param,
    false
  );
}

/**
 * 新闻->新增/修改
 */
export async function addEditNews(param: any, edit: Boolean) {
  let url = edit
    ? `${prefixpath}/dev-api/news/news/edit`
    : `${prefixpath}/dev-api/news/news`;
  const res = edit ? put(url, param, false) : post(url, param, false);
  return res;
}
/**
 * 新闻->查询
 */
export async function queryNewsInfo(id: number) {
  const res = get(`${prefixpath}/dev-api/news/news/${id} `, {}, false);
  return res;
}

/**
 * 新闻->删除
 */
export async function delEditNews(code: string | number) {
  const res = del(`${prefixpath}/dev-api/news/news/${code}`, {}, false);
  return res;
}
/**
 * 获取学科列表Tree数据
 */
export async function querySubjectTree() {
  const res = post(`${prefixpath}/dev-api/learn/front/subject/tree`, {}, false);
  return res;
}
/**
 * 获取中心分类Tree数据
 */
export async function queryCategoryTree() {
  const res = post(
    `${prefixpath}/dev-api/learn/category/center/category/info`,
    {},
    false
  );
  return res;
}
/**
 * 课程置顶状态修改
 */
export async function updateCourseTopStatus(param: any) {
  const res = post(
    `${prefixpath}/dev-api/learn/course/top/status/update`,
    param,
    false
  );
  return res;
}
/**
 * 测试直播跳转
 */
export async function testJumpLive() {
  const res = get(
    `${prefixpath}/dev-api/learn/api/cc/live/user/enter?roomId=CB13C9017CCC79979C33DC5901307461&ccUserId=AA247F3728571B49`,
    {},
    false
  );
  return res;
}
/**
 * 测试直播跳转
 */
export async function getCourseDefaultImg() {
  const res = post(
    `${prefixpath}/dev-api/learn/course/getOriginalImage`,
    {},
    false
  );
  return res;
}
/**
 * 新冠专项分类(前端用)
 */
export async function queryCovid19CategoryListInfo() {
  return await post(
    `${prefixpath}/dev-api/learn/category/covid19/list/info
  `,
    {},
    false
  );
}
/**
 * 新冠专项课程列表
 */
export async function queryCovid19SpecialCourseList(data: any, params: any) {
  const { pageNum, pageSize } = params;
  return await post(
    `${prefixpath}/dev-api/learn/front/special/covid19/course/list?pageNum=${pageNum}&pageSize=${pageSize}
  `,
    data,
    false
  );
}
/**
 * 正在直播列表
 */
export async function queryStartLiveCourseList(
  params: any,
  secondCategoryId: number
) {
  const { pageNum, pageSize } = params;
  return await post(
    `${prefixpath}/dev-api/learn/front/user/start/live/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    { secondCategoryId },
    false
  );
}
/**
 * 即将开始直播列表
 */
export async function queryInComingLiveCourseList(
  params: any,
  secondCategoryId: number
) {
  const { pageNum, pageSize } = params;
  return await post(
    `${prefixpath}/dev-api/learn/front/user/un/live/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    { secondCategoryId },
    false
  );
}
/**
 * 获取回放直播列表
 */
export async function queryReplayLiveCourseList(
  params: any,
  secondCategoryId: number
) {
  const { pageNum, pageSize } = params;
  return await post(
    `${prefixpath}/dev-api/learn/front/user/replay/live/list?pageNum=${pageNum}&pageSize=${pageSize}`,
    { secondCategoryId },
    false
  );
}
/**
 * 活动会议分类(前端用)
 */
export async function queryActivityCategoryListInfo(classificationId: number) {
  return await post(
    `${prefixpath}/dev-api/learn/category/activity/${classificationId}/list/info
  `,
    {},
    false
  );
}
/**
 * 江苏活动会议课程列表
 */
export async function queryActivitySpecialCourseList(data: any, params: any) {
  const { pageNum, pageSize } = params;
  return await post(
    `${prefixpath}/dev-api/learn/front/special/activity/course/list?pageNum=${pageNum}&pageSize=${pageSize}
  `,
    data,
    false
  );
}
/**
 * 广西活动会议课程列表
 */
export async function queryActivityByGXSpecialCourseList(
  data: any,
  params: any
) {
  const { pageNum, pageSize } = params;
  return await post(
    `${prefixpath}/dev-api/learn/front/special/activity/course/list?pageNum=${pageNum}&pageSize=${pageSize}
  `,
    data,
    false
  );
}
/**
 * 跳转直播
 */
export async function linkToCClive(roomId: string, ccUserId: any) {
  return await get(
    `${prefixpath}/dev-api/learn/api/cc/live/user/enter?roomId=${roomId}&ccUserId=${ccUserId}`,
    {},
    false
  );
}
/**
 * 获取广告图
 */
export async function queryAdvertisementImg() {
  const url =  NODE_ENV === "production"
  ? `https://op.mvwchina.com/report/advertising/findList?appCode=xy`
  : `https://country.imed.org.cn/county-domain-frontend/report/advertising/findList?appCode=xy`
  return await get(
    url,
    {},
    false
  );
}
/**
 * 广告埋点
 * @param data
 * @param stayLength
 * @param uumsId
 * @returns
 */
export async function querSaveUserWatchTime(
  data: any,
  stayLength = 0,
  uumsId: string,
  type: number = 1
) {
  return await post(
    NODE_ENV === "production"
      ? `https://op.mvwchina.com/report/operation/log/saveList`
      : `https://country.imed.org.cn/county-domain-frontend/report/operation/log/saveList`,
    {
      channelAppCode: "xy",
      channelClientType: "PC",
      deviceCode: getBrowser(),
      //设备系统
      deviceOs: "Windows",
      // 停留时间
      stayLength,
      data,
      humanId: uumsId,
      operationType: type,
    },
    false
  );
}
/**
 * 记录直播点击次数
 */
export async function queryRecordLiveNumber(liveId: number) {
  return await post(
    `${prefixpath}/dev-api/learn/front/update/live/${liveId}/click/count
  `,
    {},
    false
  );
}
/**
 * 增加新闻阅读量
 */
export async function queryAddNewsClickNums(data: any) {
  return await put(
    `${prefixpath}/dev-api/news/news/edit/click
  `,
    data,
    false
  );
}
